import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const PasswordChangePageTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  whiteSpace: 'nowrap',
  width: '100%',
  maxWidth: 400,
  margin: 0,
  marginBottom: '10%',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(2),
}));

export const PasswordChangeSubmitButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(6),
  height: theme.spacing(7),
  fontSize: 'large',
  '&:not(.Mui-disabled)': {
    backgroundColor: theme.palette.secondary.main,
  },
}));
